import { render, staticRenderFns } from "./UpdateALiteracyBadge.vue?vue&type=template&id=af778ad0&scoped=true"
import script from "./UpdateALiteracyBadge.vue?vue&type=script&lang=js"
export * from "./UpdateALiteracyBadge.vue?vue&type=script&lang=js"
import style0 from "./UpdateALiteracyBadge.vue?vue&type=style&index=0&id=af778ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af778ad0",
  null
  
)

export default component.exports